var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'mixin', 'core', 'app-common/view/base', 'app-common/component/loader', 'app-common/component/notification', 'component/document-uploader', 'app-common/component/api-call', 'template/import-excel/uploader.htm', 'template/import-excel/landing.htm'], function($, _, mixin, core, BaseView, loader, NotificationSupport, documentUploader, apiCall, uploaderTemplate, landingTemplate) {
  var ImportFromExcelPage;
  return ImportFromExcelPage = (function(_super) {

    __extends(ImportFromExcelPage, _super);

    function ImportFromExcelPage() {
      ImportFromExcelPage.__super__.constructor.apply(this, arguments);
    }

    ImportFromExcelPage.prototype.pageId = 'import-excel';

    ImportFromExcelPage.prototype.initialize = function(options, params) {
      ImportFromExcelPage.__super__.initialize.apply(this, arguments);
      this.render();
      return this.initUploader();
    };

    ImportFromExcelPage.prototype.render = function() {
      ImportFromExcelPage.__super__.render.call(this, landingTemplate);
      return this.setNotifications({
        can_not_upload: {
          type: 'error',
          text: 'Unknown error'
        }
      });
    };

    ImportFromExcelPage.prototype.initUploader = function() {
      var _this = this;
      return documentUploader.initUploader({
        extensions: ['xls', 'xlsx'],
        template: uploaderTemplate,
        params: {
          uploadContext: 'import-excel',
          clientId: core.getCurrentClientId()
        },
        container: $('.upload-wrapper')[0],
        onSubmit: function() {
          return loader.init();
        },
        onComplete: function(id, fileName, responseJSON) {
          var importResult;
          importResult = apiCall('import', "excel/file/" + responseJSON.result + "/client/" + (core.getCurrentClientId()), 'POST');
          importResult.always(function() {
            return loader.hide();
          });
          importResult.fail(function() {
            return _this.showNotification('can_not_upload');
          });
          return importResult.done(function(response) {
            var type;
            type = (response != null ? response.status : void 0) === 'SUCCESSFUL' ? 'success' : 'error';
            return _this.showNotification({
              type: type,
              text: response != null ? response.description : void 0
            });
          });
        }
      });
    };

    return ImportFromExcelPage;

  })(mixin.of(BaseView, NotificationSupport));
});
